export type AssetTier = 'T1' | 'T2' | 'T3' | 'T4' | 'T5'

/**
 * Tier comes from `window.matchedSavings` — the savings band lead-engine actually matched the
 * session at (including promotion), not the lead's stated answer. Keys are the
 * canonical savings band strings; both 1M+ bands map to T1 and the under-25k band is T5.
 */
const SAVINGS_BAND_TO_TIER: Record<string, AssetTier> = {
  '[5000000, max)': 'T1',
  '[1000000, 5000000)': 'T1',
  '[250000, 1000000)': 'T2',
  '[100000, 250000)': 'T3',
  '[25000, 100000)': 'T4',
  '(min, 25000)': 'T5'
}

/**
 * Maps a matched-savings band string to its asset tier. Missing, empty, or unrecognized bands
 * resolve to undefined, so tier-gated personalization rules simply don't match and the user
 * sees the default copy.
 */
export function resolveAssetTier (matchedSavings: string | undefined): AssetTier | undefined {
  if (typeof matchedSavings !== 'string') {
    return undefined
  }
  return SAVINGS_BAND_TO_TIER[matchedSavings.trim()]
}
